const hexImages = [
  {
    "id": 1,
    "title": "Problems",
    "src": require("./hexagon-1.png")
  },
  {
    "id": 2,
    "title": "Research",
    "src": require("./hexagon-2.png")
  },
  {
    "id": 3,
    "title": "Thinking",
    "src": require("./hexagon-3.png")
  },
  {
    "id": 4,
    "title": "Brainstorm",
    "src": require("./hexagon-4.png")
  },
  {
    "id": 5,
    "title": "Solution",
    "src": require("./hexagon-5.png")
  }
]
export default hexImages
